// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1_gYo","cls2":"FeedbackModal-cls2__U_ FeedbackModal-cls1_gYo"};